export const fmtUSD = (n) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(n || 0));

export const fmtNum = (n) =>
  new Intl.NumberFormat("es-MX").format(Number(n || 0));

export const fmtPct = (n) => `${Number(n || 0).toFixed(1)}%`;

export const fmtDate = (d) => {
  if (!d) return "—";
  try {
    // Una fecha sola ("2026-11-13") no debe correrse un día por la zona horaria.
    return new Date(/^\d{4}-\d{2}-\d{2}$/.test(String(d)) ? `${d}T12:00:00` : d).toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return d;
  }
};

export const fmtMonth = (p) => {
  if (!p) return "—";
  const [y, m] = p.split("-");
  const months = ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"];
  return `${months[parseInt(m, 10) - 1] || m} ${y}`;
};
